export default {
	teamEmail: {
		default: "opre+{teamCode}{'@'}opre.io",
		development: "calendar+{teamCode}{'@'}ics-dev.teaming.com",
		test: "calendar+{teamCode}{'@'}ics-test.teaming.com",
	},
	emailHint: "Click to copy.",
	emailHintCopied: "Copied!"
};
